"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import React from "react";
import { ContentTabProvider } from "../brain/ContentTabContext";
import WavesMessagesWrapper from "../shared/WavesMessagesWrapper";
interface Props {
  readonly children: ReactNode;
}
const MessagesDesktop: React.FC<Props> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <WavesMessagesWrapper defaultPath="/messages" showLeftSidebar={true}>{children}</WavesMessagesWrapper>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const MessagesDesktopWithProvider: React.FC<Props> = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ContentTabProvider><MessagesDesktop {...props} /></ContentTabProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default MessagesDesktopWithProvider;